import { TaskControlPayloadType, TaskControlResultType } from 'types/tasks';

import axios from '../config/axiosPrivate';


const TASK_QUEUE_STATUS_PATH = '/tasks/queue-status';
const TASK_QUEUE_PENDING_BREAKDOWN_PATH = '/tasks/pending-breakdown';
const TASK_QUEUE_CONTROL_PATH = '/tasks/control';

export const getTaskQueueStatus = async () => {
  const response = await axios.get(TASK_QUEUE_STATUS_PATH);
  return response.data;
};

export const getPendingTaskBreakdown = async () => {
  const response = await axios.get(TASK_QUEUE_PENDING_BREAKDOWN_PATH);
  return response.data;
};

export const updateTaskControl = async (payload: TaskControlPayloadType): Promise<TaskControlResultType> => {
  const response = await axios.post(TASK_QUEUE_CONTROL_PATH, payload);
  return response.data;
};
